export default __webpack_public_path__ + "static/media/Medidas.69ce7af6.svg";